import {PlantUpmIdProvider} from '@features/pom'
import {useUpmPlantsContext} from '@hconnect/upm'
import React from 'react'
import {useParams} from 'react-router'

export const PomPlantIdProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const {plantId} = useParams<{plantId: string}>()
  const upmPlants = useUpmPlantsContext()

  if (!plantId) {
    throw new Error('The plantId is not set in the URL.')
  }

  const upmPlant = upmPlants[plantId]
  if (!upmPlant) {
    throw new Error(`No UPM plant data found for plant ${plantId}`)
  }

  return <PlantUpmIdProvider upmId={upmPlant.upmId}>{children}</PlantUpmIdProvider>
}
